import React, { useCallback, useEffect, useState, useContext, useRef } from "react";
import { get_zeus_resources_images_path }  from "../../../atom/Apollo_links";
import { apollo_useStyles, options_reviewstatus, options_reviewreason, options_mimetype, options_mimetype_zeus }  from "../../../atom/Apollo_styles";
import { ApolloMessage } from "../../../atom/Apollo_Mesasge";
import { ApolloContext } from "../../../atom/Apollo_Context";
import { CrAssetsImageRow, LogRecordDialog } from "./AdvertisementModelZeus";
import { useParams } from "react-router-dom";
import {useDropzone} from "react-dropzone";

import axios from "axios";
import {getResultType, isSuccessApi} from "../../../atom/Apollo_ApiRequest3";
import moment from 'moment'

import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Modal from '@material-ui/core/Modal';

import Card from "@material-ui/core/Card/Card";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions/CardActions";

import Typography from '@material-ui/core/Typography';

import {ApolloDataTable, STORAGE_KEY} from "../../../atom/Apollo_DataTable";
import {MUIDataTableColumnDef, MUISortOptions, SelectableRows} from "mui-datatables";
import {ApolloTabPanel, ApolloTabs2} from "../../../atom/Apollo_Tabs"
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField/TextField";
import makeAnimated from "react-select/animated";
import Select from "react-select";
import {Controller, useForm} from "react-hook-form";
import {
    checkInvalidCharForImageFileName,
    sizeRules,
    imageSizeMessages,
    validateImage,
} from "../../../common/Apollo_CommonUtil";
import {
    ApolloEventRecord,
    createLogDate,
    createUserLogItemListFromNumber,
    createUserLogItemListFromString,
    ItemList,
    LogData,
} from "../../../atom/Apollo_EventRecord";
import {ZEUS_DELIVERY_TYPE, ZEUS_PMP_TYPE} from "../../../atom/Apollo_styles";

const animatedComponents = makeAnimated();

function getModalStyle() {
    return {
        top: `50%`,
        left: `50%`,
        transform: `translate(-50%, -50%)`,
    };
}

const useStyles = makeStyles(theme => ({
    root: {
        Width: "100%",
        backgroundColor: theme.palette.background.paper,
        position: 'relative',
        overflow: 'auto',
        height: 550,
    },
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    paper: {
        position: 'absolute',
        width: '60%',
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
    },
    tablescroll: {
       overflow: "scroll",
       maxHeight: 550,
    },
    cardaction: {
        marginLeft : "auto",
        marginRight : "10",
    },
    inline: {
        display: 'inline',
    },
}));

function a11yProps(index: any) {
    return {
        id: `scrollable-auto-tab-${index}`,
        'aria-controls': `scrollable-auto-tabpanel-${index}`,
    };
}

interface TabPanelProps {
    children?: React.ReactNode;
    index: any;
    value: any;
}

function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}>
            {children}
        </div>
    );
}

// @ts-ignore
export const CreativeModal = ({ platformAccountId, tabinit, isSuccess, setSelectedFileOrigin, setSelectedCreative, selectIndex, selectedFileOrigins, setSelectedFileOrigins, isSelectedAdGroup, campaignType, pmpType, optionPlacementSettings}) => {
    const {state, dispatch} = React.useContext(ApolloContext);
    const dialogClasses = useStyles();
    const classes = apollo_useStyles();
    const [modalStyle] = useState(getModalStyle);
    const [open, setOpen] = useState(false);
    const [tabstate, setTabstate] = useState( tabinit );
    const [changeSelect, setChangeSelect] = React.useState(false);

    const [imageFiles, setImageFiles] = useState("");
    const [imageWidth, setImageWidth] = useState(0);
    const [imageHeight, setImageHeight] = useState(0);
    const [imageMimeType, setImageMimeType] = useState(options_mimetype_zeus[0]);
    const [dataURI, setDataURI] = useState("");
    const [errorMessages, setErrorMessages] = useState("");
    const processing = useRef(false);
    const [imageSizeType, setImageSizeType] = useState([0]);
    const [imageSizeStr, setImageSizeStr] = useState([""]);

    const {control, formState, register, handleSubmit} = useForm();

    const reader = new FileReader();

    const handleListItemClick = (
        fileName: string,
        url: string,) => {
        setSelectedCreative(url);
        selectedFileOrigins[selectIndex-1]=fileName;
        setSelectedFileOrigins(selectedFileOrigins);
        setSelectedFileOrigin(fileName);

        handleClose();
    };

    const handleOpen = async () => {
        let valImageSizeType = []
        // キャンペーン種別・取引形式・プレースメントから許容できる画像サイズを判定する
        if (campaignType === ZEUS_DELIVERY_TYPE.DSP && (pmpType === ZEUS_PMP_TYPE.PLACEMENT_DESIGNATION || pmpType === ZEUS_PMP_TYPE.PREMIUM_PLACEMENT_DESIGNATION)) {
            // 分類番号を判別
            for (const optionPlacementSetting of optionPlacementSettings) {
                optionPlacementSetting.placementSettingTypeSizes.forEach(function(element: any) {
                    const h = element.adSizeHeight
                    const w = element.adSizeWidth
                    for (const sizeRule of sizeRules) {
                        if ((sizeRule.maxWidth ? w === sizeRule.maxWidth : w === sizeRule.minWidth) && h === sizeRule.maxHeight) {
                            valImageSizeType.push(sizeRule.imageSizeType)
                            break
                        }
                    }
                });    
            }
        } else {
            if (campaignType === ZEUS_DELIVERY_TYPE.PERFORMANCE) {
                valImageSizeType.push(1)
                valImageSizeType.push(2)
                valImageSizeType.push(3)
                valImageSizeType.push(4)
            } else {
                switch (pmpType) {
                    case ZEUS_PMP_TYPE.OPEN_AUCTION:
                        valImageSizeType.push(1)
                        valImageSizeType.push(2)
                        break;
                }
            }
        }
        setImageSizeType(valImageSizeType)

        // アセット画像選択ダイアログに表示するメッセージを詰める
        let valImageSizeStr = []
        for (const val of valImageSizeType) {
            const imageSizeMessage = imageSizeMessages.find((element) => element.imageSizeType === val)
            if (imageSizeMessage !== undefined) {
                valImageSizeStr.push(imageSizeMessage.Message)
            }
        }
        setImageSizeStr(valImageSizeStr)

        setOpen(true);
    };

    const handleClose = () => {
        // アップロードタブの内容をクリア
        setImageFiles("");
        setImageWidth(0);
        setImageHeight(0);
        setImageMimeType(options_mimetype_zeus[0]);
        setDataURI("");

        setTabstate(tabinit);
        setOpen(false);
    };

    // 画像サイズメッセージを改行された形に整形
    const sizeMessageIndention = () => {
        const texts = imageSizeStr.map((item, index) => {
            return (
                <React.Fragment key={index}>{item}<br/></React.Fragment>
            )    
        })
        return texts
    }

    const {data, setmsg} = useContext(ApolloMessage);
    const [images, setImages] = useState<CrAssetsImageRow[]>([]);
    // const [videos, setVideos] = useState<CrAssetsVideoRow[]>([]);

    let image1: Array<CrAssetsImageRow> = [];

    // 画像
    useEffect(()=>{
        if (tabstate === 0) return;

        const url = `${process.env.REACT_APP_API_ENDPOINT}${get_zeus_resources_images_path}?account_id=${platformAccountId}&per_page=9999&page=1&sort=created&direction=desc`;

        axios.get(url, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${state.accesstoken}`,
            }
        }).then((response) => {
            if (response !== null && response.data !== null) {
                response.data.forEach(function (r1: any) {
                    if (r1.reviewStatus !== 3) {
                        image1.push(r1);
                    }
                })
                setImages(image1.filter((x) => imageSizeType.includes(x.imageSizeType)));
            }
        })
        .catch((error) => {
            setmsg ({
                type: "setMessage",
                payload: {
                    ...data,
                    open:true,
                    type:"error",
                    message:"データ取得に失敗しました"
            }});
        })
    }, [tabstate])

    // 動画
    // useEffect(()=>{
    //     const url = `${process.env.REACT_APP_API_ENDPOINT}${get_zeus_resources_videos_path}?accountId=${zeusaccountid}&perPage=100&page=1&sort=created&direction=desc&width=100&height=100`;
        
    //     axios.get(url, {
    //         headers: {
    //             'Content-Type': 'application/json',
    //             'Authorization': `Bearer ${state.accesstoken}`,
    //         }
    //     }).then((response) => {
    //         setVideos(response.data);
    //     })
    //     .catch((error) => {
    //         setmsg ({
    //             type: "setMessage",
    //             payload: {
    //                 ...data,
    //                 open:true,
    //                 type:"error",
    //                 message:"データ取得に失敗しました"
    //         }});
    //     })
    // }, [])

    /** アップロード */
    const onSubmit = handleSubmit(async (formData: any) => {
        if (processing.current) return;
        if (formState.isSubmitting) return;

        if (!imageFiles[0]) {
            setmsg({
                type: "setMessage",
                payload: {
                    ...data,
                    open: true,
                    type: "error",
                    message: "ファイルを選択してください"
                }
            });
            return
        }

        if (acceptedFiles[0].type !== (formData.mimeTypeId).label) {
            setmsg({
                type: "setMessage",
                payload: {
                    ...data,
                    open: true,
                    type: "error",
                    message: "選択したMIME種別とアップロードファイルの形式が異なります。アップロードファイルと同じMIME種別を選択してください"
                }
            });
            return
        }

        if (errorMessages) {
            setmsg({
                type: "setMessage",
                payload: {
                    ...data,
                    open: true,
                    type: "error",
                    message: errorMessages
                }
            });
            return
        }

        let isSuccess = false;
        processing.current = true;
        let result: CrAssetsImageRow = {
            id: 0,
            createdAt: "",
            updatedAt: "",
            lastUpdateUserId: "",
            url: "",
            adAccountId: 0,
            mimeTypeId: 0,
            width: 0,
            height: 0,
            originalFileName: "",
            reviewStatus: 0,
            reviewReason: 0,
            imageSizeType: 0,
            adAccountName: "",
        };

        const executeLog: LogData = createUserLog(
            state,
            "パフォーマンス広告",
            "広告アセット",
            "作成",
            "広告（パフォーマンス広告）アセット画像選択",
            null,
            {
                platformAccountId: platformAccountId,
                fileName: acceptedFiles[0].name,
                mimeType: imageMimeType.label,
            },
        );
        ApolloEventRecord({...executeLog, logType: "execute"});

        const params = new FormData();
        params.append('adAccountId', platformAccountId);
        params.append('mimeTypeId', (formData.mimeTypeId).value);
        params.append('width', formData.width);
        params.append('height', formData.height);
        params.append('fileName', acceptedFiles[0].name);
        params.append('reviewStatus', '2');
        params.append('file', imageFiles[0]);

        const url = process.env.REACT_APP_API_ENDPOINT + get_zeus_resources_images_path;
        await axios.post(
            url, 
            params, 
            {
                headers: {
                    'Authorization': `Bearer ${state.accesstoken}`,
                }
            }
        ).then(response => {
            isSuccess = true;
            setmsg({
                type: "setMessage",
                payload: {
                    ...data,
                    open: true,
                    type: "success",
                    message: "アセット画像を登録しました",
                }
            });
            result = response.data;
            executeLog.targetID = result.id.toString();
            executeLog.targetName = result.originalFileName;
        }).catch(error => {
            setmsg({
                type: "setMessage",
                payload: {
                    ...data,
                    open: true,
                    type: "error",
                    message: error?.response?.data?.message || error?.message
                }
            });
        }).finally(() => {
            ApolloEventRecord({
                ...executeLog,
                eventDate: moment().format("YYYY-MM-DD HH:mm:ss"),
                logType: "result",
                result: isSuccess ? "成功" : "失敗"
            });
            processing.current = false;
        });

        if (isSuccess) {
            handleListItemClick(
                "img"+ String(result.id) +" (幅"+result.width+", 高さ"+result.height+")", 
                result.url
            );
        }
    });

    const onDrop = useCallback((acceptedFiles, fileRejections) => {
        let datauri = '';

        if (fileRejections[0]?.errors[0].code == 'file-invalid-type') {
            setImageFiles("");
            setDataURI(datauri);
            setmsg({
                type: "setMessage",
                payload: {
                    ...data,
                    open: true,
                    type: "error",
                    message: "画像ファイル（jpeg, gif, png）を設定してください。"
                }
            });
            return
        }

        if (fileRejections[0]?.errors[0].code == 'file-too-large') {
            setImageFiles("");
            setDataURI(datauri);
            setmsg({
                type: "setMessage",
                payload: {
                    ...data,
                    open: true,
                    type: "error",
                    message: "ファイルサイズが600KBを越えています。"
                }
            });
            return
        }

        if (!acceptedFiles[0]) {
            setImageFiles("");
            setDataURI(datauri);
            setmsg({
                type: "setMessage",
                payload: {
                    ...data,
                    open: true,
                    type: "error",
                    message: "画像のアップロードに失敗しました"
                }
            });
            return
        }

        setImageFiles(acceptedFiles);

        const fileNameOrigin: string = acceptedFiles[0].name
        const fileNameArray: string[] = fileNameOrigin.split('.')
        fileNameArray.pop()
        const fileName: string = fileNameArray.join(".")

        setChangeSelect(changeSelect);

        switch (acceptedFiles[0].type) {
            case "image/png":
                setImageMimeType(options_mimetype[0]);
                break;
            case "image/jpeg":
                setImageMimeType(options_mimetype[1]);
                break;
            case "image/gif":
                setImageMimeType(options_mimetype[2]);
                break;
            default:
                break;
        }

        setChangeSelect(!changeSelect);

        reader.onload = () => {
            datauri = reader.result as string;
            setDataURI(datauri);

            const img = new Image();
            let errormessage = '';
            setErrorMessages(errormessage);

            img.addEventListener('load', () => {
                let width = img.width;
                let height = img.height;
                setImageWidth(img.width);
                setImageHeight(img.height);
                console.log(width);
                console.log(height);
                let aspect =  Math.round(width * 10 / height) / 10;
                console.log(aspect);

                // 分類番号からチェック内容を判定する
                let err = validateImage(width, height, imageSizeType)
                if (err !== null) {
                    setErrorMessages(err);
                    return
                }

                const imgNameErrorMsg = checkInvalidCharForImageFileName(fileName)
                if (imgNameErrorMsg !== "") {
                    let localErrorMessage = imgNameErrorMsg
                    if (localErrorMessage === "禁止文字が含まれます。") {
                        localErrorMessage = "入力不可文字が含まれています。"
                    }
                    setErrorMessages("画像ファイル名エラー：" + localErrorMessage);
                    return
                }
                if (fileNameOrigin.length > 255) {
                    setErrorMessages("ファイル名が255文字を超えています");
                    return
                }
            });
            img.src = datauri;
        }
        if (acceptedFiles[0]) {
            reader.readAsDataURL(acceptedFiles[0]);
        }
    }, [imageSizeType]);

    const {acceptedFiles, getRootProps, getInputProps} = useDropzone({
        accept: 'image/jpeg, image/gif, image/png',
        maxSize: 1024*600,
        onDrop,
    });

    const columns: MUIDataTableColumnDef[] = [
        {
            name: "id",
            label: "広告アセットID",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "originalFileName",
            label: "画像ファイル名",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "url",
            label: "画像プレビュー",
            options: {
                filter: false,
                sort: false,
                setCellProps: () => ({style: {textAlign: "center"}}),
                customBodyRender: (value: string) => {
                    return (
                        <img
                            src={value}
                            alt=""
                            style={{maxHeight: "80px"}}
                        />
                    );
                },
            }
        },
        {
            name: "width",
            label: "幅(px)",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "height",
            label: "高さ(px)",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "",
            label: "",
            options: {
                filter: false,
                sort: false,
                customBodyRenderLite: (idx: number) => {
                    const data = images[idx];
                    return (
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={() => handleListItemClick(
                                // data.id, 
                                "img"+ String(data.id) +" (幅"+data.width+", 高さ"+data.height+")", 
                                data.url
                            )}
                        >
                            選択
                        </Button>
                    );
                },
            }
        },
    ]

    const sortOrder: MUISortOptions = {
        name: "id",
        direction: 'desc',
    }
    const selectableRows: SelectableRows = 'none';
    const options = {
        filter: true,
        download: false,
        print: false,
        sort: true,
        sortOrder: localStorage.getItem(STORAGE_KEY.APOLLO_CREATIVE_DIALOG) ? undefined : sortOrder,
        selectableRows: selectableRows,
        rowsPerPage: 10,
        rowsPerPageOptions: [10, 25, 50],
        jumpToPage: true,
        expandableRows: false,
        expandableRowsHeader: false,
        expandableRowsOnClick: false,
        storageKey: STORAGE_KEY.APOLLO_CREATIVE_DIALOG,
        textLabels:{
            body: {noMatch: "該当データが存在しません"}
        },
    }

    return (
        <div>
            <Button 
                variant="contained"
                color="primary"
                disabled={isSuccess || !isSelectedAdGroup ? true : false}
                onClick={handleOpen}>
                {/* {tabinit === 0 ? '画像選択' : '動画選択'} */}
                {'画像選択'}
            </Button>

            <Modal
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                open={open}
                onClose={handleClose}>
                <div style={modalStyle} className={dialogClasses.paper}>
                    <>
                        <Card className={dialogClasses.root} elevation={0}>
                            <CardContent>
                            <Grid container spacing={3}>
                                <Grid item xs={6}>
                                    <Typography>設定可能な画像サイズ</Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <Typography variant="body2" gutterBottom component="div" color="textSecondary">
                                                【幅・高さ】<br/>
                                                {sizeMessageIndention()}
                                    </Typography>
                                </Grid>
                            </Grid>
                            </CardContent>
                            <ApolloTabs2 value={tabstate} setValue={setTabstate} tablabel={["アップロード", "アップロードした画像"]}/>
                            <ApolloTabPanel value={tabstate} index={0}>
                                <CardContent>
                                    <Grid container spacing={3}>
                                        <Grid item xs={12}>
                                            <Typography variant="body2" gutterBottom component="div" color="textSecondary">
                                                【サイズ】最大600KB<br/>
                                                【ファイル形式】jpeg, gif, png
                                            </Typography>
                                            <Grid container spacing={1} alignItems="center">
                                                <Grid item xs={6}>
                                                    <section className="container">
                                                        <div {...getRootProps()}>
                                                            <input {...getInputProps()} />
                                                            <div className={classes.droparea}>
                                                                <p className={classes.p}>ここにファイルをドラッグ＆ドロップ<br/>もしくは、クリックして選択</p>
                                                            </div>
                                                        </div>
                                                    </section>
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <aside style={{marginTop: '1em'}}>
                                                        <img src={dataURI} style={{width: '40%'}}/>
                                                    </aside>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Grid container spacing={1}>
                                                <Grid item xs={4}>
                                                    <TextField
                                                        required
                                                        id="width"
                                                        name="width"
                                                        label="幅（画像選択後自動入力）"
                                                        variant="filled"
                                                        fullWidth
                                                        autoComplete="幅"
                                                        value={imageWidth}
                                                        inputProps={{type: 'number'}}
                                                        inputRef={register}
                                                    />
                                                </Grid>
                                                <Grid item xs={4}>
                                                    <TextField
                                                        required
                                                        id="height"
                                                        name="height"
                                                        label="高さ（画像選択後自動入力）"
                                                        variant="filled"
                                                        fullWidth
                                                        autoComplete="高さ"
                                                        value={imageHeight}
                                                        inputProps={{type: 'number'}}
                                                        inputRef={register}
                                                    />
                                                </Grid>
                                                <Grid item xs={4}>
                                                    <Typography variant="subtitle1" gutterBottom component="div" color="inherit">
                                                        MIME種別
                                                    </Typography>
                                                    <Controller
                                                        required
                                                        id="mimeTypeId"
                                                        name="mimeTypeId"
                                                        as={Select}
                                                        control={control}
                                                        closeMenuOnSelect={true}
                                                        components={animatedComponents}
                                                        isDisabled={true}
                                                        key={changeSelect ? "Loading" : "Loaded"}
                                                        defaultValue={imageMimeType}
                                                        options={options_mimetype_zeus}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </CardContent>
                                <CardActions className={classes.cardaction}>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={onSubmit}
                                        className={classes.button}
                                        disabled={imageFiles === "" || formState.isSubmitting || processing.current}
                                    >
                                    アップロード
                                    </Button>
                                    <Button
                                        variant="contained"
                                        color="default"
                                        onClick={handleClose}
                                        className={classes.button}
                                        disabled={processing.current}
                                    >
                                    キャンセル
                                    </Button>
                                </CardActions>
                            </ApolloTabPanel>
                            <ApolloTabPanel value={tabstate} index={1}>
                                <Grid item xs={12}>
                                    <ApolloDataTable
                                        title=""
                                        data={images}
                                        columns={columns}
                                        options={options}
                                    />
                                </Grid>
                                <CardActions className={classes.cardActionButton}>
                                    <Button
                                        variant="contained"
                                        color="default"
                                        onClick={handleClose}
                                        className={classes.button}
                                    >
                                    閉じる
                                    </Button>
                                </CardActions>
                            </ApolloTabPanel>
                            {/* <TabPanel value={tabstate} index={1}>
                                <List className={dialogClasses.root}>
                                    {videos ?
                                    videos.map((video) => (
                                        <ListItem
                                            button
                                            selected={selectedIndex === video.id}
                                            onClick={(event) => handleListItemClick(event, video.id, "d"+('000'+video.id).slice(-3))}>
                                            <ListItem alignItems="flex-start">
                                                <ListItemAvatar style={{ marginRight: 25 }}>
                                                    <iframe width="220" height="150" src={video.url}
                                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture">
                                                    </iframe>
                                                </ListItemAvatar>
                                                <ListItemText
                                                    primary={"動画ID: d"+('000'+video.id).slice(-3)}
                                                    secondary={
                                                        <>
                                                        <Typography
                                                            component="span"
                                                            variant="body2"
                                                            className={dialogClasses.inline}
                                                            color="textPrimary">
                                                            審査状態: {valueToLabel(`${video.reviewStatus}`, options_reviewstatus)}
                                                            {video.reviewStatus === 3 ? ' (' + valueToLabel(`${video.reviewReason}`, options_reviewreason) + ')' : ''}
                                                        </Typography>
                                                        <Typography variant="caption" display="block" gutterBottom>
                                                            ファイル名: {video.fileName} <br />
                                                            width: {video.width}, height: {video.height}
                                                        </Typography>
                                                        </>
                                                    } />
                                            </ListItem>
                                        </ListItem>
                                    )) : ""}
                                </List>
                            </TabPanel> */}
                        </Card>
                    </>
                </div>
            </Modal>
        </div>
    );
};

const createUserLog = (
    apolloContex: any,
    menu: string,
    category: string,
    actionType: string,
    displayName: string,
    beforeInfo: LogRecordDialog | null,
    afterInfo: LogRecordDialog,
) => {
    const items: ItemList[] = [
        createUserLogItemListFromNumber("プラットフォームアカウントID", "platformAccountId", beforeInfo, afterInfo),
        createUserLogItemListFromString("MIME種別", "mimeType", beforeInfo, afterInfo),
        createUserLogItemListFromString("ファイル名", "fileName", beforeInfo, afterInfo),
    ];

    const retObj = createLogDate(
        apolloContex,
        menu,
        category,
        actionType,
        displayName,
        items,
    );

    return retObj
}
